import axios from "axios";
import { getAccessToken, setAccessToken } from "./tokenStore";

const api = axios.create({
    baseURL: process.env.REACT_APP_URI,
    withCredentials: true,
});

/* ================= REQUEST ================= */
api.interceptors.request.use((config) => {
    const token = getAccessToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

/* ================= REFRESH LOCK ================= */
let isRefreshing = false;
let refreshPromise = null;

/* ================= RESPONSE ================= */
api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (
            error.response?.status === 401 &&
            !originalRequest._retry &&
            !originalRequest.url.includes("/auth/refresh")
        ) {
            originalRequest._retry = true;

            try {
                if (!isRefreshing) {
                    isRefreshing = true;

                    refreshPromise = axios
                        .post(
                            `${process.env.REACT_APP_URI}/auth/refresh`,
                            {},
                            { withCredentials: true }
                        )
                        .then((res) => {
                            setAccessToken(res.data.accessToken);
                            return res.data.accessToken;
                        })
                        .finally(() => {
                            isRefreshing = false;
                            refreshPromise = null;
                        });
                }

                const newToken = await refreshPromise;

                originalRequest.headers.Authorization = `Bearer ${newToken}`;
                return api(originalRequest);
            } catch (err) {
                setAccessToken(null);
                refreshPromise = null;
                isRefreshing = false;
                window.location.replace("/");
                return Promise.reject(err);
            }
        }

        return Promise.reject(error);
    }
);

export default api;